import { isNull } from './isNull.js';
import { isUndefined } from './isUndefined.js';
import { isNaN } from './isNaN.js';

function typeOf(value) {
    var type;
    if (isNaN(value)) {
        type = 'NaN';
    }
    else if (isNull(value)) {
        type = 'Null';
    }
    else if (isUndefined(value)) {
        type = 'Undefined';
    }
    else {
        type = constructorNameOf(value);
    }
    return type;
}
function constructorNameOf(value) {
    var name = '';
    var ctor = value.constructor;
    if (typeof ctor === 'function') {
        name = /^function (\w+)/.exec(ctor.toString())[1];
    }
    else {
        // IE 11 and Safari:
        // `typeof element.constructor` => 'object'
        // IE 11:
        // `ctor.toString()` => '[object HTMLDivElement]'
        name = /^\[object (\w+)\]$/.exec(ctor.toString())[1];
        // Safari:
        // `ctor.toString()` => '[object HTMLDivElementConstructor]'
        name = name.replace(/Constructor$/, '');
    }
    return name;
}

export { typeOf };
